export { inspirationsGetInspirationDetail } from '@/app/services/vidu';
